import React, { FC, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { Link as TLink } from '~/lib/data-contract/auto-generated/api-model';
import { Link } from '~/shared/components/Link/Link';
import { theme } from '~/theme';
import { Container } from '../Container';
import styles from './Breadcrumb.module.scss';

export interface IBreadcrumbProps {
    items: TLink[];
    shouldFloat?: boolean;
    color?: typeof theme.colors.white | typeof theme.colors.black | string;
}

const Breadcrumbs: FC<IBreadcrumbProps> = ({
    items,
    shouldFloat = false,
    color = theme.colors.black,
}) => {
    const breadcrumbRef = useRef<null | HTMLUListElement>(null);

    useEffect(() => {
        if (breadcrumbRef.current) {
            breadcrumbRef.current.scrollTo(breadcrumbRef.current.getBoundingClientRect().width, 0);
        }
    }, []);

    return (
        <Container className={clsx(styles.container, { [styles.floating]: shouldFloat })}>
            <ul className={styles.list} ref={breadcrumbRef}>
                {items.map((link, i) => {
                    const isLast = i === items.length - 1;
                    const isClickable = !isLast && !!link.url;

                    return (
                        <li
                            className={styles.item}
                            style={{ color }}
                            key={`${link.title ?? link.text}-${i}`}
                        >
                            {isClickable ? (
                                <Link {...link} href={link.url} color={color} tabIndex={0}>
                                    {link.text}
                                </Link>
                            ) : (
                                link.text
                            )}
                            {!isLast && <div className={styles.chevron}>/</div>}
                        </li>
                    );
                })}
            </ul>
        </Container>
    );
};

export default Breadcrumbs;
